export default __webpack_public_path__ + "static/media/salon-app-circle.655d4afc.png";